import { compareSemver } from './semver';
import type { ReleaseNoteItem, ReleaseNotesRelease, ReleaseNotesViewer } from './types';

export function itemVisible(item: ReleaseNoteItem, viewer: ReleaseNotesViewer): boolean {
  if (item.feature && viewer.features[item.feature] !== true) return false;
  return true;
}

export function visibleReleases(
  releases: ReleaseNotesRelease[],
  viewer: ReleaseNotesViewer,
): ReleaseNotesRelease[] {
  return releases
    .map((release) => ({
      ...release,
      items: (release.items || []).filter((item) => itemVisible(item, viewer)),
    }))
    .filter((release) => release.items.length > 0)
    .sort((a, b) => compareSemver(b.version, a.version));
}
